export const supplier = {
  "supplier.missing_id": "Supplier ID Missing",
  "supplier.no_id_provided": "No supplier ID was provided.",
  "supplier.back_to_search": "Back to Search",
  "supplier.not_found": "Supplier not found",
  "supplier.not_exist": "The supplier you are looking for does not exist.",
  "supplier.loading": "Loading details...",
  "supplier.contact_success": "Your message has been sent successfully! The supplier will contact you soon.",
  "supplier.contact_error": "An error occurred while sending. Please try again.",
  "supplier.verified": "Verified",
  "supplier.reviews_count": "reviews",
  "supplier.address": "Full address",
  "supplier.phone": "Phone",
  "supplier.email": "Email",
  "supplier.website": "Website",
  "supplier.contact": "Contact",
  "supplier.call": "Call",
  "supplier.schedule": "Schedule",
  "supplier.visit_website": "Visit website",
  "supplier.share": "Share",
  "supplier.favorite": "Favorite",
  "supplier.review_success": "Your review has been submitted successfully!",
  "supplier.review_error": "There was an error submitting your review. Please try again.",
  "supplier.login_to_review": "Log in to leave a review",
  "supplier.no_photos": "No photos available",
  "supplier.leave_review_for": "Leave a review for",
  "supplier.rating": "Rating",
  "supplier.star": "star",
  "supplier.stars": "stars",
  "supplier.comment": "Comment",
  "supplier.placeholder_comment": "Write your comment here...",
  "supplier.no_products": "No products available",
  "supplier.characters": "characters",
  "supplier.submitting": "Submitting...",
  "supplier.submit_review": "Submit Review",
  "supplier.overview": "Overview",
  "supplier.reviews": "Reviews",
  "supplier.location": "Location",
  "supplier.gallery": "Gallery",
  "supplier.products": "Products",
  "supplier.about": "About",
  "supplier.important_info": "Important information",
  "supplier.verified_by_suji": "Verified by Suji",
  "supplier.quick_response": "Quick response to requests",
  "supplier.quality_service": "Quality customer service",
  "supplier.avg_rating": "Average rating",
  "supplier.customer_reviews": "Customer reviews",
  "supplier.status": "Status",
  "supplier.leave_review": "Leave a review",
  "supplier.no_reviews": "No reviews yet",
  "supplier.first_review": "Be the first to leave a review for this business",
  "supplier.first_review_button": "Leave the first review",
  "supplier.location_access": "Location and access",
  "supplier.get_directions": "Get directions",
  "supplier.practical_info": "Practical information",
  "supplier.hours": "Hours: Mon-Fri 8am-6pm",
  "supplier.parking": "Parking available",
  "supplier.accessibility": "Disabled access",
  "supplier.contact_info": "Contact information",
  "supplier.call_now": "Call now",
  "supplier.send_message": "Send message",
  "supplier.itinerary": "Get itinerary",
  "supplier.open_website": "Open website",
  "supplier.photos": "Photos",
  "supplier.similar_businesses": "Similar businesses",
  "supplier.see_details": "See details",
  "supplier.contact_form_title": "Contact",
  "supplier.your_name": "Your name",
  "supplier.placeholder_name": "Your full name",
  "supplier.placeholder_email": "your@email.com",
  "supplier.phone_number": "Phone number",
  "supplier.placeholder_phone": "+234 xxx xxx xxxx",
  "supplier.subject": "Subject",
  "supplier.select_subject": "Select a subject",
  "supplier.quote_request": "Quote request",
  "supplier.product_info": "Product information",
  "supplier.partnership": "Partnership",
  "supplier.support": "Support",
  "supplier.other": "Other",
  "supplier.message": "Message",
  "supplier.placeholder_message": "Describe your request in detail...",
  "supplier.max_characters": "Maximum 500 characters",
  "supplier.cancel": "Cancel",
  "supplier.send": "Send",
  "supplier.sending": "Sending...",
  "supplier.feature_not_available": "This feature is not yet available",
  "supplier.internal_message": "Message",
  "supplier.message_sent_success": "Your message has been sent successfully! The supplier will contact you soon.",
  "supplier.message_sent_error": "An error occurred while sending your message. Please try again.",
  "supplier.no_email": "Supplier doesn't have email",
  "supplier.no_phone": "Supplier doesn't have phone number",
  "supplier.location_not_available": "Location not available",
  "supplier.claim_business": "Do you own this business?",
  "supplier.view_similar_products": "View all similar products",
  "supplier.price_on_request": "Price on request",

  // Error messages and loading
  "supplier.review_client": "Client",
  "supplier.form_error": "Error sending form:",
  "supplier.review_send_error": "Error sending review:",
  "supplier.message_send_error": "Error sending message:",
  "supplier.loading_timeout_title": "Loading is taking longer than expected",
  "supplier.loading_timeout_desc": "Unable to load supplier details. Please try again.",
  "supplier.retry": "Retry"
};

export default supplier;
